import React from "react";

function TagIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 13.521 13.517">
      <path
        d="M16.893,4.5H11.316L4.94,11.105a1.495,1.495,0,0,0,0,2.12l4.355,4.352a1.616,1.616,0,0,0,1.014.44,1.766,1.766,0,0,0,1.106-.44L18.02,11.26V5.627ZM15.812,8.116a1.128,1.128,0,1,1,.753-.753A1.1,1.1,0,0,1,15.812,8.116Z"
        transform="translate(-4.499 -4.5)"
      />
    </svg>
  );
}

export { TagIcon };
